import { getBuildInfo } from '../utils/buildInfo';

/**
 * The quiet "which build am I looking at" stamp at the bottom of /about.
 * Muted on purpose — it exists so a tester can read it back during a bug
 * report, not to compete with the page's content.
 */
export const BuildStamp = () => {
  const { version, build, commit, builtAt } = getBuildInfo();

  return (
    <div className="mt-10 pt-4 border-t border-gray-200">
      <p className="font-sans text-sm text-gray-500">
        {`Version ${version} (build ${build}, ${commit}) · Built ${builtAt}`}
      </p>
    </div>
  );
};
